import { HttpParams, HttpHeaders } from '@angular/common/http';

export type BgxHttpMethod = 'GET' | 'POST' | 'PATCH' | 'DELETE' | 'HEAD' | 'PUT' | 'OPTIONS';

export type BgxHttpRESTResponseType = 'arraybuffer' | 'blob' | 'json' | 'text';

export type BgxHttpRESTObserve = 'body' | 'response' | 'events';

export interface IBgxHttpRESTOptions {
  headers?:
    | HttpHeaders
    | {
        [header: string]: string | string[];
      };
  observe?: BgxHttpRESTObserve;
  params?:
    | HttpParams
    | {
        [param: string]: string | string[];
      };
  responseType?: BgxHttpRESTResponseType;
  reportProgress?: boolean;
  withCredentials?: boolean;
}

export interface IBgxHttpRESTOptionsWithBody extends IBgxHttpRESTOptions {
  body?: any;
}
